export default __webpack_public_path__ + "static/media/logo.89e9d207.png";